import {
	CLOSE_ALERT_FAIL,
	CLOSE_ALERT_SUCCESS,
	SET_ALERT_FAIL,
	SET_ALERT_SUCCESS,
} from './types';

export const setAlert = (alertType, message) => {
	return async (dispatch) => {
		try {
			var payload = {
				alertType: alertType,
				message: message,
				status: true,
			};

			dispatch(setAlertSuccess(payload));
		} catch (error) {
			dispatch(setAlertFail(error));
		}
	};
};

export const closeAlert = () => {
	return async (dispatch) => {
		try {
			dispatch(closeAlertSuccess());
		} catch (error) {
			dispatch(closeAlertFail(error));
		}
	};
};

const setAlertSuccess = (payload) => ({
	type: SET_ALERT_SUCCESS,
	payload,
});

const setAlertFail = (payload) => ({
	type: SET_ALERT_FAIL,
	payload,
});

const closeAlertSuccess = (payload) => ({
	type: CLOSE_ALERT_SUCCESS,
	payload,
});
const closeAlertFail = (payload) => ({
	type: CLOSE_ALERT_FAIL,
	payload,
});
